import React, { useMemo } from 'react';
import ProductList from './ProductList';
import { AlbumState } from '@/data/models/albumState';
import { useTranslation } from 'react-i18next';
import { loadPhysicalReleasesFilters } from '@/state/actions/productGridActions';
import { FormatType } from '@/data/models/formatType';
import store from '@/state/store';
import { productListColDef } from './ProductListColDef';
import { useSelector } from 'react-redux';
import { getAuth } from '@/selectors/auth';
import { withActiveChangeRequestColumn } from './ChangeRequestColumn';

const defaultReleasesStateFilters = [AlbumState.Released];

export default function ReleasesList() {
  const { t } = useTranslation();
  const { hasInternalAccess } = useSelector(getAuth);

  const setReleasesGridParams = (searchParams: URLSearchParams | null) => {
    return loadPhysicalReleasesFilters({
      physicalReleasesGridParams: searchParams,
    });
  };

  const physicalReleasesGridParams =
    store.getState().productGridState.physicalReleasesGridParams;
  const releasesProductListColDef = useMemo(
    () => withActiveChangeRequestColumn(productListColDef, hasInternalAccess),
    [hasInternalAccess]
  );

  return (
    <ProductList
      defaultStateFilters={defaultReleasesStateFilters}
      productListHeader={t('product.productList.productList')}
      storedGridParams={physicalReleasesGridParams}
      setGridParams={setReleasesGridParams}
      formatType={FormatType.Physical}
      productListColDef={releasesProductListColDef}
      gridName="physical-releases"
      preferPrimaryPpdReferencePrice
    />
  );
}
